export const GET_PAYMENT_CURRENCY = 'GET_PAYMENT_CURRENCY';

